/** Log out user after this many ms of no activity. Override via VITE_INACTIVITY_LOGOUT_MINUTES (default 60). */
export const INACTIVITY_LOGOUT_MS = (() => {
  const minutes =
    typeof import.meta.env?.VITE_INACTIVITY_LOGOUT_MINUTES !== "undefined"
      ? Number(import.meta.env.VITE_INACTIVITY_LOGOUT_MINUTES)
      : 60;
  const clamped =
    Number.isFinite(minutes) && minutes > 0
      ? Math.min(Math.max(minutes, 1), 1440)
      : 60; // 1 min–24h
  return clamped * 60 * 1000;
})();

/** Longer idle window when "Remember me" is checked (8 hours). */
export const REMEMBER_ME_INACTIVITY_LOGOUT_MS = 8 * 60 * 60 * 1000;

/** How often to proactively refresh access tokens (before 15m JWT expiry). */
export const PROACTIVE_REFRESH_MS = 10 * 60 * 1000;

/** Auth bootstrap timeouts – avoid false logouts on slow networks. */
export const AUTH_CHECK_TIMEOUT_MS = 10_000;
export const GET_ME_TIMEOUT_MS = 8_000;
export const REFRESH_TIMEOUT_MS = 8_000;

const PUBLIC_ROUTES = ["/login", "/signup"];

export function isPublicRoute(pathname: string): boolean {
  const normalized = pathname.replace(/\/$/, "");
  return (
    PUBLIC_ROUTES.includes(normalized) ||
    pathname.startsWith("/login") ||
    pathname.startsWith("/signup")
  );
}

/**
 * Initial loading state for AuthProvider.
 * For public routes: false. For protected routes with token: true until checkAuth completes.
 */
export function getInitialLoadingState(): boolean {
  if (typeof window === "undefined") return true;
  const pathname = window.location.pathname;
  if (isPublicRoute(pathname)) return false;
  return true; // Protected routes: keep loading until checkAuth completes
}
